import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";

import { composeWithDevTools } from "@redux-devtools/extension";

import * as reducers from "./reducers";
import dynamicReducers from "./reducers";

let rootReducer = combineReducers({
  ...reducers,
  ...dynamicReducers,
});

const composeEnhancers = composeWithDevTools({
  // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk)),
);

export { store };
